var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-vertical-timeline',{attrs:{"data":_vm.historyData}})
}
var staticRenderFns = []

export { render, staticRenderFns }